import { Tag } from 'antd';
import {
  getServiceRequestStateTitles,
  SERVICE_REQUEST_STATUS_COLORS,
} from '@/components/Kanban/ServiceRequests/Calendar/utils';
import { ServiceRequestStatus } from '@/typings/models/ServiceRequest';

export default function ServiceRequestStatusTag({status, fontSize}: {fontSize?: string, status: keyof typeof ServiceRequestStatus }) {
  const title = getServiceRequestStateTitles()[status]
  const color = SERVICE_REQUEST_STATUS_COLORS[status]
  return <Tag color={color} style={{fontSize, borderRadius: '100px', border: 'none'}}>{title}</Tag>
}
